import { createContext, use, type ReactNode } from "react";
import type { RuntimeConfig } from "./config.js";

/**
 * **إعدادُ وقت التشغيل — يُقرأ حيث يُحتاج، لا يُمرَّر من شاشةٍ إلى شاشة.**
 *
 * وبدأتُ أمرّر `apiBaseUrl` بروباً إلى كل شاشةٍ ترسم وجهاً، **فصار واجباً
 * يتكرّر**: أربعُ شاشاتٍ اليوم، وكلُّ شاشةٍ تُضاف غداً. وهو نفسُ الصنف الذي
 * نزل إلى الموضع الواحد في مفتاح منع التكرار — «واجبٌ يتكرّر في ستّين موضعاً
 * يُنسى في أحدها حتماً».
 *
 * **ولا يُقرأ العنوانُ من ثابتٍ مكتوب**: هو ما يجعل نفسَ الحزمة تعمل عند
 * المشتري وفي الديمو وعند TWING — وتسعُ حوادثَ في v2 سببُها عنوانٌ مخبوزٌ
 * وقت البناء.
 */
const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({
  config,
  children,
}: {
  readonly config: RuntimeConfig;
  readonly children: ReactNode;
}): ReactNode {
  return <RuntimeConfigContext value={config}>{children}</RuntimeConfigContext>;
}

/**
 * **ويسقط صريحاً خارج مضيفه** — لا يرجع إلى `/api/v1` بالسكوت.
 *
 * فرجوعٌ صامتٌ إلى ثابتٍ يعمل على جهاز المطوّر ويكسر عند المشتري، **ولا موضعَ
 * يقول لماذا**. وهذا الخطأ يظهر في أول رسمةٍ في التطوير، فلا يصل إلى أحد.
 */
export function useRuntimeConfig(): RuntimeConfig {
  const config = use(RuntimeConfigContext);
  if (!config) throw new Error("useRuntimeConfig: لا مضيفَ إعدادٍ فوق هذه الشاشة");
  return config;
}
